import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { RequirementFormPage } from './requirement-form.page';
import { AddeddFlawComponent } from './addedd-flaw/addedd-flaw.component';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
// import { ItemListComponent } from '../requirement-form/flaw-creation-modal/item-list/item-list.component';
// import { EnclosureSpotListComponent } from '../requirement-form/flaw-creation-modal/enclosure-spot-list/enclosure-spot-list.component';
// import { FailureDetailListComponent } from '../requirement-form/flaw-creation-modal/failure-detail-list/failure-detail-list.component';

import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
import { ImagesComponent } from 'src/app/shared-components/images/images.component';
import { SharedModule } from 'src/app/shared-module/shared-module.module';
// import { FileChooser } from '@awesome-cordova-plugins/file-chooser/ngx';
import { FileHelpersService } from 'src/app/core/services/file-helpers/file-helpers.service';
import { EnclosureListComponent } from './enclosure-list/enclosure-list.component';
import { ItemSpotListComponent } from './item-spot-list/item-spot-list.component';
import { FailuresDetailListComponent } from './failures-detail-list/failures-detail-list.component';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { AddFailureModalComponent } from './add-failure-modal/add-failure-modal.component';
import { TranslateModule } from '@ngx-translate/core';
// import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';

const routes: Routes = [
  {
    path: '',
    component: RequirementFormPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    RouterModule.forChild(routes),
    TranslateModule
  ],
  providers: [
    Camera, File, WebView,// FilePath, //FileChooser,
    FileHelpersService, DatePipe,
    Keyboard,// Chooser
  ],
  declarations: [RequirementFormPage, AddeddFlawComponent, EnclosureListComponent, ItemSpotListComponent, FailuresDetailListComponent, AddFailureModalComponent],//, ItemListComponent, EnclosureSpotListComponent, FailureDetailListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class RequirementFormPageModule { }
